import { Injectable } from '@angular/core';
import {
  AbstractAuxiliaryDataSchemaService,
  FieldSchema,
  FieldSchemaIdentifier,
  GetFieldSchemaResponse,
  GetMultiFieldSchemaResponse,
  ListFieldSchemasResponse,
  UpdateFieldSchemaRequest,
  UpdateSchemaFieldMask,
} from './schema-interface';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CRMFieldSchemaApiService } from '@vendasta/crm';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContactSchemaService implements AbstractAuxiliaryDataSchemaService {
  constructor(private readonly crmFieldSchemaApiService: CRMFieldSchemaApiService) {}

  listFieldSchemas(
    partnerId: string,
    onlyArchived: boolean,
    cursor: string,
    pageSize: number,
  ): Observable<ListFieldSchemasResponse> {
    return this.crmFieldSchemaApiService
      .listFieldSchema({
        namespace: partnerId,
        crmObjectType: 'Contact',
        filters: {
          onlyArchived: onlyArchived,
        },
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize,
        },
      })
      .pipe(
        map((resp) => {
          return {
            fieldSchemas: resp.fieldSchemas,
            nextPageToken: resp.pagingMetadata,
          } as unknown as ListFieldSchemasResponse;
        }),
      );
  }

  getFieldSchema(id: FieldSchemaIdentifier): Observable<GetFieldSchemaResponse> {
    return this.crmFieldSchemaApiService
      .getMultiFieldSchema({
        namespace: id.partnerId,
        crmObjectType: 'Contact',
        fieldId: [id.fieldId],
      })
      .pipe(
        map((resp) => {
          return {
            fieldSchema: resp.fieldSchemas[0],
          } as unknown as GetFieldSchemaResponse;
        }),
      );
  }

  // These aren't needed for how the contact schema service is being used
  createFieldSchema(_: FieldSchema): Observable<HttpResponse<null>> {
    throw new Error('Method not implemented.');
  }

  updateFieldSchema(_: UpdateFieldSchemaRequest, __: UpdateSchemaFieldMask): Observable<HttpResponse<null>> {
    throw new Error('Method not implemented.');
  }

  getMultiFieldSchema(_: FieldSchemaIdentifier[]): Observable<GetMultiFieldSchemaResponse> {
    throw new Error('Method not implemented.');
  }

  archiveFieldSchema(_: FieldSchemaIdentifier): Observable<HttpResponse<null>> {
    throw new Error('Method not implemented.');
  }

  unarchiveFieldSchema(_: FieldSchemaIdentifier): Observable<HttpResponse<null>> {
    throw new Error('Method not implemented.');
  }
}
